module.exports = __webpack_public_path__ + "img/NEM-OFFICIAL-LOGO_ORIGINAL.ff7819ec.png";